import { useRequireCurrentProviderKey } from "@versatile-credit-apply/sdk"
import type { RouteRecordRaw } from "vue-router"

export const AccountLookupRoutes: RouteRecordRaw[] = [
  {
    path: "account-lookup",
    children: [
      {
        path: "",
        redirect: () => {
          const provider = useRequireCurrentProviderKey()
          return `/apply/providers/${provider.value}/application/account-lookup`
        },
      },
      {
        path: "lookup",
        name: "account-lookup-perform-lookup",
        component: () => import("./AccountLookupPage.vue"),
      },
      {
        path: "not-found",
        name: "account-lookup-not-found",
        component: () => import("./AccountLookupNotFoundPage.vue"),
      },
    ],
  },
]
